export function findControls(controlsEnviron, controlsClass) {
    const controls = controlsEnviron.querySelector(controlsClass);
    const buttonPrev = controls.querySelector(".js-slider-button-prev");
    const buttonNext = controls.querySelector(".js-slider-button-next");
    const pagination = controls.querySelector(".js-slider-pagination");

    return { buttonPrev, buttonNext, pagination };
}